// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.bridge.BridgeExportTokenRequest */
/* istanbul ignore next */
@GandalfModel
export class BridgeExportTokenRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.ActivityTemplateAbbreviation)
	@GandalfValidator({ notNull: { message: 'Template is required' } })
	@GandalfProperty({ designType: constants.ActivityTemplateAbbreviation, isRequired: true })
	activityTemplateAbbreviation!: constants.ActivityTemplateAbbreviation;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
